import { render, staticRenderFns } from "./IssueDescriptionTableCell.vue?vue&type=template&id=14c604a5&scoped=true"
import script from "./IssueDescriptionTableCell.vue?vue&type=script&lang=js"
export * from "./IssueDescriptionTableCell.vue?vue&type=script&lang=js"
import style0 from "./IssueDescriptionTableCell.vue?vue&type=style&index=0&id=14c604a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c604a5",
  null
  
)

export default component.exports